import { EditorView } from "@tiptap/pm/view";
import { isSuggestionMenuOpen, KeyCode } from "./Extensions";
import { readFileAsDataUrl } from "./TextEditorConvertor";

export const handleKeyDown = (event: KeyboardEvent): boolean => {
  if (event.key === KeyCode.Enter) {
    // If the suggestions popover is open, Enter should select the focused suggestion.
    // (Don't block it with the single-line editor Enter suppression.)
    if (isSuggestionMenuOpen()) {
      return false;
    }
    event.preventDefault();
    return true;
  }
  return false;
};

export const handlePaste = (event: ClipboardEvent, view: EditorView, insertImageIntoView: (view: EditorView, src: string) => void): boolean => {
    const dt = event.clipboardData;
    if (!dt) {
        return false;
      }

      const files = Array.from(dt.files ?? []).filter((f) =>
        f.type?.startsWith("image/")
      );
      if (!!files.length) {
        event.preventDefault();
        files.forEach(async (file) => {
          const src = await readFileAsDataUrl(file);
          if (src) {
            insertImageIntoView(view, src);
          }
        });
        return true;
      }

      const items = Array.from(dt.items ?? []);
      const imageItems = items.filter((item) =>
        item.type?.startsWith("image/")
      );

      if (!!imageItems.length) {
        event.preventDefault();

        imageItems.forEach((item) => {
          const file = item.getAsFile();
          if (!file) {
            return;
          }
          readFileAsDataUrl(file).then((src) => {
            if (!!src) {
              insertImageIntoView(view, src);
            }
          });
        });
        return true;
      }

      return false;

}